import { mapActions } from "vuex";

// const handleCSharpDeleteToken = async (taskId) => {
//     window.console.log('handleCSharpDeleteToken for taskId ' + taskId);
//     await loginService.logout();
//     await WorkAuthentication.terminateAuthentication();
// };

const handleCSharpConfirmChangeInstance = async (taskId) => {
    window.console.log('handleCSharpConfirmChangeInstance for taskId ' + taskId);
}

export default {
    mounted() {
        window.handleCSharpConfirmChangeInstance = handleCSharpConfirmChangeInstance;
    },
    methods: {
        ...mapActions('mobileWrapperTasks', ['setTask']),
        async invokeChangeInstance() {
            if (!this.$isMobileDevice()) { return }

            window.console.log("try invokeCSharpChangeInstance");

            try {
                let taskId = await this.setTask({ callback: handleCSharpConfirmChangeInstance });
                // eslint-disable-next-line no-undef
                return invokeCSharpChangeInstance(taskId); // RENAME OR REMOVING WILL BREAK MOBILEWRAPPER
            } catch (e) {
                window.console.error(e)
            }
        },
    },
    beforeDestroy() {
        delete window.handleCSharpConfirmChangeInstance;
    }
}
